<div class="row" *ngIf="widgetType && w && w.timeSeriesList">
  <div class="col-lg-6">
    <div class="form-group">
        <h3>Data Source A</h3>
        <app-time-series-select [timeSeriesDetail]="w.timeSeriesList[0]" [enableTagMatch]="true"></app-time-series-select>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group">
      <h3>Display Calculation A</h3>        
      <select [(ngModel)]="w.displayA" class="form-select">
        <option>Latest</option>
        <option>Average</option>
        <option>Maximum</option>
        <option>Minimum</option>
        <option>Change</option>
      </select>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group">
        <h3>Data Source B</h3>
        <app-time-series-select [timeSeriesDetail]="w.timeSeriesList[1]" [enableTagMatch]="true"></app-time-series-select>
    </div>
  </div>
  <div class="col-lg-6">
    <div class="form-group">
      <h3>Display Calculation B</h3>        
      <select [(ngModel)]="w.displayB" class="form-select">
        <option>Latest</option>
        <option>Average</option>
        <option>Maximum</option>
        <option>Minimum</option>
        <option>Change</option>
      </select>
    </div>
  </div>
  <div class="col-lg-4">
    <div class="form-group">
      <h3>Name</h3>
      <input type="text" placeholder="widget name" max="15" class="form-control" [(ngModel)]="w.name">
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group">
      <h3>Units</h3>
      <input type="text" placeholder="unit type" max="5" class="form-control" [(ngModel)]="w.units">
    </div>
  </div>
  <div class="col-lg-5">
    <div class="form-group">
      <h3>Valid Period</h3>        
      <app-time-period [(period)]="w.period" [type]="'text'"></app-time-period>
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <h3>Refresh (Seconds)</h3>
      <input
        min="60"
        type="text"
        placeholder="refresh interval"
        class="form-control"
        [(ngModel)]="w.refreshInterval"
      />
    </div>
  </div>
  <div class="col-lg-3">
    <div class="form-group input-group-sm">
      <label>Left Axis</label>
      <div class="input-group">
        <input type="text" placeholder="min" class="form-control" [(ngModel)]="w.min"/>
        <input type="text" placeholder="max" class="form-control" [(ngModel)]="w.max"/>
      </div>
    </div>
  </div>
</div>

